import { useAppSelector } from '@/redux/store'
import { selectIsMuted } from '@/redux/store/modules/audio.slice'
import React, { useEffect, useRef } from 'react'
import useSound from 'use-sound'

const bgMusic = '/sound/bingo/bingoBg.mp3'

export function BgSound() {
  const [play, { stop, pause }] = useSound(bgMusic, {
    loop: true,
  })

  const muted = useAppSelector(selectIsMuted)

  const muteRef = useRef(muted)

  useEffect(() => {
    muteRef.current = muted

    if (muted) {
      stop()
    } else {
      play()
    }
  }, [muted])

  useEffect(() => {
    const enableMusic = () => {
      if (!muteRef.current) {
        play()
      }
      document.removeEventListener('click', enableMusic)
      document.removeEventListener('touchstart', enableMusic)
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (!muteRef.current) {
          play()
        }
      } else {
        pause()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    document.addEventListener('click', enableMusic)
    document.addEventListener('touchstart', enableMusic)

    return () => {
      pause()
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      document.removeEventListener('click', enableMusic)
      document.removeEventListener('touchstart', enableMusic)
    }
  }, [play])

  return <></>
}
